import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Col, InputGroup, FormControl } from 'react-bootstrap';
import isArray from 'lodash/isArray';

import Strings from '../../../../app/shared/Strings';
const AssetUtil = require('../../util/asset');
import ErrorBox from '../common/ErrorBox';
import AssetImage from '../common/AssetImage';
import SingleAssetInput from '../common/SingleAssetInput';

const propTypes = {
    licenseMetaData: PropTypes.shape({
        bullet_points: PropTypes.arrayOf(PropTypes.string),
        bullet_points_how: PropTypes.arrayOf(PropTypes.string),
        competency_name: PropTypes.string,
        competency_part: PropTypes.number,
        competency_total_parts: PropTypes.number,
        subcompetency: PropTypes.bool,
        audience: PropTypes.string,
        badge_image_url: PropTypes.string,
    }).isRequired,
    error: PropTypes.object,
    disabled: PropTypes.bool,
    uploadImageDisabled: PropTypes.bool,
    onUpdate: PropTypes.func.isRequired,
    onUpdateLicense: PropTypes.func.isRequired,
    onUpdateBadgeImage: PropTypes.func.isRequired,
    onUpdateBadgeImageFailed: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const defaultProps = {
    disabled: false,
    uploadImageDisabled: false,
    error: null,
};

const VALID_BP_INDICES = [0, 1, 2];

function UpdateShortCourseLicenseMetaDataModal(props) {
    function onUpdateBulletPoint(curArr, propName, index, value) {
        const bulletPoints = curArr.map((curVal, i) => {
            if (i === index) {
                return value;
            }
            
            return isArray(curArr) && curArr[i] ? curArr[i] || '' : '';
        });

        onUpdate(propName, bulletPoints);
    }

    function onRemoveBulletPoint(curArr, propName, index) {
        const newArr = curArr.filter((curVal, i) => {
            return i !== index;
        });

        onUpdate(propName, newArr);
    }

    function onAddBulletPoint(curArr, propName) {
        const newArr = curArr.concat(['']);
        onUpdate(propName, newArr);
    }

    function onUpdate(propName, value) {
        props.onUpdate({ ...props.licenseMetaData, [propName]: value });
    }

    const curBulletPointsWhat = props.licenseMetaData.bullet_points || [];
    const curBulletPointsHow = props.licenseMetaData.bullet_points_how || [];
    return (
        <Modal
            show
            enforceFocus={false}
            backdrop={false}
            animation={false}
            keyboard
            onHide={props.onClose}
        >
            <Modal.Header closeButton onHide={props.onClose}>
                <Modal.Title>Add Short Course License</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ErrorBox error={props.error} />
                <Form>
                    <Form.Group controlId={`mzl-clmd-bp-what`}>
                        <Form.Label>{Strings['en'].short_course.modals.update_lic_meta.WHAT_YOULL_LEARN_LBL}</Form.Label>
                        {curBulletPointsWhat.map((val, i) => {
                            return (
                                <InputGroup className="mb-3" key={i}>
                                    <FormControl
                                        placeholder={`${Strings['en'].short_course.modals.update_lic_meta.BULLET_POINT_LBL} ${i+1}`}
                                        aria-label={`${Strings['en'].short_course.modals.update_lic_meta.BULLET_POINT_LBL} ${i+1}`}
                                        aria-describedby="mzl-clmd-bp-what"
                                        type="text"
                                        value={val || ''}
                                        onChange={(e) => onUpdateBulletPoint(curBulletPointsWhat, 'bullet_points', i, e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button
                                            variant="danger"
                                            onClick={(e) => onRemoveBulletPoint(curBulletPointsWhat, 'bullet_points', i)}
                                        >
                                            {Strings['en'].common.DELETE}
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            );
                        })}
                        <Button
                            variant="primary"
                            className="block"
                            onClick={(e) => onAddBulletPoint(curBulletPointsWhat, 'bullet_points')}
                        >
                            + {Strings['en'].common.ADD}
                        </Button>
                    </Form.Group>
                    <Form.Group controlId={`mzl-clmd-bp-how`}>
                        <Form.Label>{Strings['en'].short_course.modals.update_lic_meta.HOW_YOULL_LEARN_LBL}</Form.Label>
                        {curBulletPointsHow.map((val, i) => {
                            return (
                                <InputGroup className="mb-3" key={i}>
                                    <FormControl
                                        placeholder={`${Strings['en'].short_course.modals.update_lic_meta.BULLET_POINT_LBL} ${i+1}`}
                                        aria-label={`${Strings['en'].short_course.modals.update_lic_meta.BULLET_POINT_LBL} ${i+1}`}
                                        aria-describedby="mzl-clmd-bp-how"
                                        type="text"
                                        value={val || ''}
                                        onChange={(e) => onUpdateBulletPoint(curBulletPointsHow, 'bullet_points_how', i, e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button
                                            variant="danger"
                                            onClick={(e) => onRemoveBulletPoint(curBulletPointsHow, 'bullet_points_how', i)}
                                        >
                                            {Strings['en'].common.DELETE}
                                        </Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            );
                        })}
                        <Button
                            variant="primary"
                            className="block"
                            onClick={(e) => onAddBulletPoint(curBulletPointsHow, 'bullet_points_how')}
                        >
                            + {Strings['en'].common.ADD}
                        </Button>
                    </Form.Group>
                    <hr />
                    <Form.Group controlId="mzl-clmd-subc">
                        <Form.Check>
                            <Form.Check.Input
                                checked={props.licenseMetaData.subcompetency || false}
                                onChange={(e) => onUpdate('subcompetency', e.target.checked)}
                            />
                            <Form.Check.Label className="margin-left-sm">{Strings['en'].short_course.modals.update_lic_meta.SUBCOMPETENCY_LBL}</Form.Check.Label>
                        </Form.Check>
                    </Form.Group>
                    <Form.Group controlId="mzl-clmd-cmpt-name">
                        <Form.Label>{Strings['en'].short_course.modals.update_lic_meta.CMPT_NAME_LBL}</Form.Label>
                        <Form.Control
                            type="text"
                            value={props.licenseMetaData.competency_name}
                            onChange={(e) => onUpdate('competency_name', e.target.value)}
                        />
                    </Form.Group>
                    <Form.Row>
                        <Col>
                            <Form.Group controlId="mzl-clmd-numAssn">
                                <Form.Label>{Strings['en'].short_course.modals.update_lic_meta.CMPT_PART_LBL}</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={props.licenseMetaData.competency_part}
                                    onChange={(e) => onUpdate('competency_part', parseInt(e.target.value))}
                                />
                            </Form.Group>
                        </Col>
                        <span className="font-size-xl padding-t-lg"> / </span>
                        <Col>
                            <Form.Group controlId="mzl-clmd-numTask">
                                <Form.Label>{Strings['en'].short_course.modals.update_lic_meta.CMPT_TOTAL_PARTS_LBL}</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    value={props.licenseMetaData.competency_total_parts}
                                    onChange={(e) => onUpdate('competency_total_parts', parseInt(e.target.value))}
                                />
                            </Form.Group>
                        </Col>
                    </Form.Row>
                    <Form.Group controlId="mzl-clmd-aud">
                        <Form.Label>{Strings['en'].short_course.modals.update_lic_meta.AUDIENCE_LBL}</Form.Label>
                        <Form.Control
                            type="text"
                            value={props.licenseMetaData.audience}
                            onChange={(e) => onUpdate('audience', e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="mzl-clmd-bimg">
                        <Form.Label className="block">{Strings['en'].short_course.modals.update_lic_meta.BADGE_IMAGE_LBL}</Form.Label>
                        {(!!props.licenseMetaData.badge_image_url) &&
                            <AssetImage
                                className="block parent-constrained"
                                src={props.licenseMetaData.badge_image_url}
                                alt={Strings['en'].short_course.modals.update_lic_meta.BADGE_IMAGE_LBL}
                            />
                        }
                        <div className="">
                            <SingleAssetInput
                                buttonOnly
                                input_id="mzl-clmd-bimg"
                                disabled={props.uploadImageDisabled}
                                browseText={Strings['en'].short_course.modals.update_lic_meta.UPLOAD_BADGE_IMAGE_LBL}
                                assetType="image"
                                assetRole="normal"
                                accept="image/*"
                                onChange={props.onUpdateBadgeImage.bind(null, props.licenseMetaData)}
                                onError={props.onUpdateBadgeImageFailed}
                                validateAssetType={AssetUtil.validateImageMimeType}
                            />
                        </div>
                </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={props.disabled}
                    onClick={props.onUpdateLicense}
                >
                    {Strings['en'].common.UPDATE}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

UpdateShortCourseLicenseMetaDataModal.propTypes = propTypes;
UpdateShortCourseLicenseMetaDataModal.defaultProps = defaultProps;

export default UpdateShortCourseLicenseMetaDataModal;